import { useCallback, useEffect, useState } from 'react';
import { axiosInstance } from '../../../Helper/Api/axios.instance';
import { AppConfig } from '../../../Config/app-config';
import { useUserContext } from '../../../context/user.context';

type TransactionType = {
  id: number;
  timestamp: string;
  transactionHash: string;
  blockNumber: number;
  l1Amount: number;
  l2Amount: number;
  l1Token: string;
};

export const useTransaction = () => {
  const { isLoggedIn } = useUserContext();
  const [transactionList, setTransactionList] = useState<TransactionType[]>([]);

  const fetchTransactionList = useCallback(async () => {
    if (!isLoggedIn) return;
    try {
      const { data } = await axiosInstance.get<{
        items: TransactionType[];
        total: number;
      }>(AppConfig.apiRoutes.listTransaction());

      setTransactionList(data?.items);
    } catch (error) {
      console.error(error);
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (isLoggedIn) void fetchTransactionList();
  }, [isLoggedIn]);

  return {
    transactionList,
    fetchTransactionList,
  };
};
